import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerCouponsSharePage } from './manager-coupons-share.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerCouponsSharePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerCouponsSharePageRoutingModule {}
